export enum ApiErrorType {
  AUTHENTICATION_ERROR = 'AuthenticationError',
  AUTHORIZATION_ERROR = 'AuthorizationError',
  INPUT_ERROR = 'InputError',
  INTERNAL_ERROR = 'InternalError',
  RESOURCE_ERROR = 'ResourceError',
  SERVICE_PROVIDER_ERROR = 'ServiceProviderError',
  VALIDATION_ERROR = 'ValidationError'
}

export enum AuthenticationErrorCode {
  AUTHENTICATION_TOKEN_EXPIRED = 'authentication_token_expired',
  AUTHENTICATION_TOKEN_KID_MISSING = 'authentication_token_kid_missing',
  AUTHENTICATION_TOKEN_INVALID_CLIENT_ID = 'authentication_token_invalid_client_id',
  AUTHENTICATION_TOKEN_INVALID_ISSUER = 'authentication_token_invalid_issuer',
  AUTHENTICATION_TOKEN_INVALID_SIGNATURE = 'authentication_token_invalid_signature',
  AUTHENTICATION_TOKEN_MALFORMED = 'authentication_token_malformed',
  AUTHENTICATION_TOKEN_PUBLIC_KEY_NOT_FOUND = 'authentication_token_public_key_not_found',
  AUTHORIZATION_HEADER_MALFORMED = 'authorization_header_malformed',
  AUTHORIZATION_HEADER_MISSING = 'authorization_header_missing',
  WEBHOOK_AUTHENTICATION_FAILED = 'webhook_authentication_failed'
}

export enum AuthorizationErrorCode {
  FORBIDDEN = 'forbidden',
  RATE_LIMIT_EXCEEDED = 'rate_limit_exceeded'
}

export enum InputErrorCode {
  BAD_REQUEST = 'bad_request',
  UNEXPECTED_WEBHOOK_PAYLOAD = 'unexpected_webhook_payload'
}

export enum InternalErrorCode {
  INTERNAL_SERVER_ERROR = 'internal_server_error'
}

export enum ResourceErrorCode {
  CARD_NOT_FOUND_BY_FINGERPRINT = 'card_not_found_by_fingerprint',
  NOT_FOUND = 'not_found',
  PATH_NOT_FOUND = 'path_not_found'
}

export enum ServiceProviderErrorCode {
  PAYMENT_CAPTURE_FAILED = 'payment_capture_failed',
  UNEXPECTED_PROVIDER_ERROR = 'unexpected_provider_error'
}

export enum ValidationErrorCode {
  CART_ITEM_REQUIRED_SUB_ITEM_MISSING = 'cart_item_required_sub_item_missing',
  DELIVERY_ADDRESS_REQUIRED = 'delivery_address_required',
  DELIVERY_UNAVAILABLE_FOR_LOCATION = 'delivery_unavailable_for_location',
  CART_ITEM_SNOOZED = 'cart_item_snoozed',
  CART_ITEM_UNAVAILABLE = 'cart_item_unavailable',
  MENU_CATEGORY_ITEM_MERCHANT_INVALID = 'menu_category_item_merchant_invalid',
  ORDER_ITEM_ID_INVALID_FOR_REFUND = 'order_item_id_invalid_for_refund',
  ORDER_ITEM_ALREADY_REFUNDED = 'order_item_already_refunded',
  ORDER_ITEM_STATUS_INVALID_FOR_REFUND = 'order_item_status_invalid_for_refund',
  ORDER_ITEM_LEVEL_INVALID_FOR_REFUND = 'order_item_level_invalid_for_refund',
  ORDER_STATUS_INVALID_FOR_ACKNOWLEDGE = 'order_status_invalid_for_acknowledge',
  ORDER_STATUS_INVALID_FOR_CANCEL = 'order_status_invalid_for_cancel',
  ORDER_STATUS_INVALID_FOR_FINISH_KITCHEN_PREP = 'order_status_invalid_for_finish_kitchen_prep',
  ORDER_STATUS_INVALID_FOR_PAYMENT_CAPTURE = 'order_status_invalid_for_payment_capture',
  ORDER_STATUS_INVALID_FOR_PICK_UP_ORDER = 'order_status_invalid_for_pick_up_order',
  ORDER_STATUS_INVALID_FOR_REFUND = 'order_status_invalid_for_refund',
  ORDER_TYPE_INVALID_FOR_FINISH_KITCHEN_PREP = 'order_type_invalid_for_finish_kitchen_prep',
  ORDER_TYPE_INVALID_FOR_MERCHANT_LOCATION = 'order_type_invalid_for_merchant_location',
  ORDER_TYPE_INVALID_FOR_PICK_UP_ORDER = 'order_type_invalid_for_pick_up_order',
  PROMO_CODE_EXPIRED = 'promo_code_expired',
  PROMO_CODE_INVALID = 'promo_code_invalid',
  PROMO_CODE_REDEEMED = 'promo_code_redeemed',
  REORDER_MENU_CATEGORY_IDS_INVALID = 'reorder_menu_category_ids_invalid',
  REORDER_MENU_ITEM_IDS_INVALID = 'reorder_menu_item_ids_invalid',
  SERVICE_REQUEST_PENDING_AT_TABLE = 'service_request_pending_at_table',
  SUB_MENU_ITEM_MERCHANT_INVALID = 'sub_menu_item_merchant_invalid',
  SUB_MENU_ITEM_PRODUCT_TYPES_INVALID = 'sub_menu_item_product_types_invalid',
  VALIDATION_ERROR = 'validation_error'
}

export type ApiErrorCode =
  | AuthenticationErrorCode
  | AuthorizationErrorCode
  | InputErrorCode
  | InternalErrorCode
  | ResourceErrorCode
  | ServiceProviderErrorCode
  | ValidationErrorCode

export interface ApiError {
  message: string
  extensions: {
    code: ApiErrorCode
    type: ApiErrorType
    fields?: Record<string, string[]>
    extra?: Record<string, string>
  }
}
